import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyState: React.FC = () => {
  return (
    <Box width="full" paddingY="s48" paddingX="s24">
      <Box alignItems="center" gap="s16" width="full">
        <Icon.Large icon="page-edit" color="grey600" />
        <Box textAlign="center">
          <Text color="grey1000" size="300" weight="semibold">
            {i18n.t('performance_process.section_weights.sidepanel_empty_state.title')}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
